import React, {Component, ReactElement} from 'react';
import LoadingCard from '../LoadingCard';
import IUsageMarkScheme from '../../models/usage-analytics/IUsageMarkScheme';
import Table, { TableColumn } from '../Table';
import TableCell from '../TableCell';
import IUsageGradeThreshold from '../../models/usage-analytics/IUsageGradeThreshold';
import { gradeToStatusColour } from './GradeColourConverter';

interface AreaUsageCalculationExplanationProps {
    Title?: string;
    Explanation?: string;
    MarkScheme?: IUsageMarkScheme;
}
interface AreaUsageCalculationExplanationState {
}
export class AreaUsageCalculationExplanation extends Component<AreaUsageCalculationExplanationProps, AreaUsageCalculationExplanationState> {
    static displayName = AreaUsageCalculationExplanation.name;

    constructor(props: AreaUsageCalculationExplanationProps) {
        super(props);

        this.state = {
        };
    }

    componentDidMount(): void {

    }

    componentDidUpdate(prevProps: Readonly<AreaUsageCalculationExplanationProps>, prevState: Readonly<AreaUsageCalculationExplanationState>, snapshot?: any): void {

    }

    private static readonly columns = [
        { title: "Grade", propertyPath: "grade", flex: 1 },
        { title: "Percentage threshold", propertyPath: "minMarkPercentage", flex: 1 },
    ];

    private cellForColumn = (item: IUsageGradeThreshold, column: TableColumn, columnIndex: number): ReactElement<TableCell> | undefined => {
        switch (column.propertyPath) {
            case "grade":
                return <TableCell flex={column.flex} className={`usage-result-cell usage-result-cell--${gradeToStatusColour(item.grade)}`}>
                    <span>{item.grade}</span>
                          
                </TableCell>

            case "minMarkPercentage":
                return <TableCell flex={column.flex} className={`usage-result-cell usage-result-cell--${gradeToStatusColour(item.grade)}`}>
                    <span>{item.minMarkPercentage}%</span>
                </TableCell>;

            default:
                return undefined;
        }
    };

    render(): JSX.Element {
        if (this.props.Explanation === undefined || this.props.MarkScheme === undefined) {

            return <LoadingCard text={"Loading..."} />;
        }

        return (
            <div className="area-usage-explanation">
                <div className="title">
                    {this.props.Title}
                </div>
                <div className="description">
                    {this.props.Explanation}               
                </div>
                <Table title={"Mark Scheme"}
                    className={"usage-result-table cdb-table--enable-hover"}
                    cellForColumn={this.cellForColumn}
                    columns={AreaUsageCalculationExplanation.columns}
                    items={this.props.MarkScheme.thresholds ? this.props.MarkScheme.thresholds : []} />
            </div>
        );
    }
}